import Container from "./KindQnaContainer"


export default Container